import type { BodyRowConfig } from '@ztechapps/webui.data-tools'
import type { RouteDef, WorkOrder } from '@ztechapps/common.contract'
import { LocalDate } from '@ztechapps/webui.date'
import { Link } from 'react-router-dom'
import { ActivityListField } from '@ztechapps/webui.data-tools'
import React from 'react'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'
import { WorkOrderStatusWithProgress } from '../WorkOrderStatus/WorkOrderStatusWithProgress'
import { Tags } from '@ztechapps/webui.input'
import { QuantityWithUom } from '@ztechapps/product.webui'

const CodeColumn = (props: BodyRowConfig<WorkOrder>) => {
  const workOrderItemRoute = useInject<RouteDef>(WebuiIocKey.routes.workOrderItem)

  const { code, _id } = props
  return (
    <Link to={workOrderItemRoute.altPath({ _id })}>
      <b>{code}</b>
    </Link>
  )
}

const StatusColumn = (props: BodyRowConfig<WorkOrder>) => {
  const { status, progressNow, progressMax } = props
  return <WorkOrderStatusWithProgress status={status} progressMax={progressMax} progressNow={progressNow} />
}

const ProductColumn = (props: BodyRowConfig<WorkOrder>) => {
  const { product } = props
  const productRoute = useInject<RouteDef>(WebuiIocKey.routes.productItem)
  return <Link to={productRoute.altPath({ _id: product?._id })}>{product?.code || product?.name}</Link>
}

const QuantityColumn = (props: BodyRowConfig<WorkOrder>) => {
  const { quantity, product } = props
  return (
    <QuantityWithUom
      quantity={quantity ?? 0}
      symbol={product?.workOrderUom?.symbol}
      decimalPrecision={product?.unitOfMeasurePrecision ?? 0}
    />
  )
}

export const DataListRow = (props: BodyRowConfig<WorkOrder>) => {
  const { createdAt, completionDate, tags, remarks, remarksActivity } = props

  return (
    <>
      {props._renderDataBodyCell({
        product: <ProductColumn {...props} />,
        status: <StatusColumn {...props} />,
        code: <CodeColumn {...props} />,
        tags: <Tags dataArray={tags} />,
        remarks: <ActivityListField remarks={remarks} remarksActivity={remarksActivity} />,
        createdAt: <LocalDate value={createdAt} />,
        completionDate: <LocalDate value={completionDate} />,
        quantity: <QuantityColumn {...props} />,
      })}
    </>
  )
}
